import React from 'react';
import * as Sc from './styled';
import { BgLogoLayer } from '../components/BgLogoLayer';


type IProps = {}

export const Page6 = (props: IProps) => {

  return <Sc.Wrapper>
    <div className='container p-5'>
      <div className='fs-big mb-5'>Angebot</div>
      <div className='fs-4 mt-5'>
        <div>Erfahrener Spielplatzprüfer nach DIN EN 1176.</div>
        <div>Zertifizierter Wartungspartner der Stadt Leipzig.</div>
        <div className='hstack gap-3 mt-5'>
          <div>
            <ul>
              <li>Monatlicher Service zum - Festpreis</li>
              <li>Einrichtung Mängelmelder inkl. Inventarisierung</li>
              <li>Alle Prüfintervalle rechtssicher, Digital, in Echtzeit</li>
            </ul>
          </div>
          <div>
            <ul>
              <li>Intuitives Dashboard - Volle Transparenz</li>
              <li>Persönlicher Service</li>
              <li>Individualisierungs- und Erweiterungsmöglichkeiten</li>
            </ul>
          </div>
          <div></div>
        </div>
      </div>
    </div>
    <BgLogoLayer theme={'light'} />
  </Sc.Wrapper>;
};